<template>
    <section>
        <v-flex>
            <v-btn @click="OpenCompanyModal">Add Company Logos</v-btn>
        </v-flex>
        <app-company-logo ref="GetDetails" :dialog='AddCompanyDialog' @close='CloseCourseModal'></app-company-logo>
        <v-layout row style="width: 90%;margin: auto;">
            <v-data-table :headers="headers"
                          :items="GetCourseListDetails"
                          item-key="Course_Title"
                          class="elevation-1"
                          style="width:100%;margin-top:10px;">
                <template v-slot:headers="props">
                <tr>
                    <th v-for="header in props.headers" :key="header.text">{{ header.text }}</th>
                </tr>
                </template>
                <template v-slot:items="props">
                <tr >
                    <td class="text-xs-center">{{ props.item.Course_Title }}</td>
                    <td class="text-xs-center">
                        <v-layout row style="width: 300px;overflow: auto;margin: auto;">
                            <span v-for="(image,index) in props.item.Company_Logos" :key="index" style="border: 1px solid lightgray;margin: 4px;">
                                <v-icon @click="DeleteImage(image,props.item)" small color='red'>close</v-icon>
                                <img :id="'logo_image_table_'+index" :src="image" style="width: 70px;height: 70px;margin: 5px;" />
                            </span>
                        </v-layout>
                    </td>
                </tr>
                </template>
            </v-data-table>
    </v-layout>
    </section>
</template>
<script>
import appCompanyLogo from '../views/dialogs/CompanyLogo'

export default {
    components:{
        appCompanyLogo
    },
    data(){
        return {
            AddCompanyDialog : false,
             headers: [
                            { text: "Course Title", value: "Course_Title" },
                            { text: "Company Logos", value: "Company_Logos"  }
                        ],
        }
    },
    computed:{
        GetCourseListDetails() {
            return this.$store.getters.GetCourseDetailsList;
        }
    },
    methods:{
        OpenCompanyModal(){

            this.$refs.GetDetails.GetCourseListFromDB();
            this.AddCompanyDialog = true;
        },
        CloseCourseModal() {
            this.AddCompanyDialog = false;
        },
        DeleteImage(Image,Course){
            
            let data = { "Logo" : Image , "Course_Id": Course['_id']}
            this.$http.post(`${this.$store.getters.GetProductionUrl}/coursepreviewvideo/deletecompanylogos`,data)
                        .then(response =>{

                            this.$store.commit('UpdateCourseDetails',response['data']['response'])
                            this.$eventHub.$emit('SNACK_BAR',{ "Show" : true ,"Text": "Successfully Uploaded Image","Color":"green","Close": false });
                             
                        })
                        .catch(err =>{

                            this.$eventHub.$emit('SNACK_BAR',{ "Show" : true ,"Text": "Failed To Upload Image","Color":"red","Close": false });
                        })
        }
    },
    mounted() {

        this.$http.post(`${this.$store.getters.GetProductionUrl}/course/getallcoursedetailslist`)
                .then(response => {

                    this.$store.commit("SetCourseDetailList", response["data"]["response"]);
                    this.$eventHub.$emit("LOADING",'false')
                })
                .catch(err => {
                    this.$eventHub.$emit("LOADING",'false')
                    this.$eventHub.$emit("SNACK_BAR", { Show: true, Text: "Error while Fetching Data", Color: "red", Close: false });
                });
  }
}
</script>
<style>

</style>